<template>
	<div class="my-table">
		<!-- 面包屑组件 -->
		<div class="searchBox flexCenter">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t("myShare.txt1")}}</span>
				<span>{{$t("myShare.txt2")}} / {{$t("myShare.txt3")}}</span>
			</div>
			<div class="flexEnd">
				<div class="searchBtn" @click="handleDeleteShare">{{$t("myShare.txt4")}}</div>
			</div>
		</div>
		<!-- 面包屑 -->
		<el-card class="tableCard">
			<el-table ref="table" :data="dataList" v-loading="loading"  @selection-change="handleSelectionChange" @row-click="rowClick" >
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column :label="$t('myShare.txt17')">
					<template slot-scope="scope">
						<div class="flex align-center link">
							<span>
								<!-- <img :src="getRowImg(scope.row)" class="mr-10" width="30"/> -->
								{{getFileName(scope.row.fileVos)}}
							</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column :label="$t('myShare.txt5')" >
					<template slot-scope="scope">
						<span>{{scope.row.shareType == 1 ? $t('myShare.txt6') : $t('myShare.txt7')}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('myShare.txt18')">
					<template slot-scope="scope">
						<span>{{scope.row.receiveUsername}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('myShare.txt8')">
					<template slot-scope="scope">
						<span>{{formatDate(scope.row.createTime)}}</span>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
	</div>
</template>

<script>
	import { formatDate } from "@/plugins/date.js";
	import {
		fileTypes,
		getFileSize
	} from "@/utils/index";
	export default {
		data() {
			return {
				fileTypes,
				isList: true,
				multipleSelection: [],
				//用于获取数据列表
				queryInfo: {
					cmptName: "",
					endCreateTm: "",
					pageNum: 1,
					pageSize: 10,
					productTmplCmptId: "",
					projName: "",
					spvTm: "",
					startCreateTm: "",
					submitterName: "",
					witnCde: "",
					witnType: "",
				},
				dataList: [],
				total: 0,
				loading: false,
			};
		},
		created() {
			this.loadData();
		},
		methods: {
			getFileSize,
			getRowImg(row) {
				if(row.sharePaths && row.sharePaths.length > 1) {
					return this.fileTypes.wen
				}
				if(!row.sharePaths) return '';
				const type = this.getFileType(row.sharePaths[0].sharePathKey.path);
				if(!type) {
					return this.fileTypes.folder
				}
				// if(row.fileVos[0].directory) {
				// }
				let res = this.fileTypes[type];
				return res || this.fileTypes.default
			},
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, "yyyy-MM-dd hh:mm:ss");
			},
			getFileName(list) {
				if(list && list.length == 1) {
					return list[0].path
				}else if(list && list.length>1){
					return list.map(item =>{
						return item.path
					}).join('、 ') +  this.$t('myShare.txt9')
				}else{

				}
			},
			// 数据加载(监理现场见证记录列表)
			async loadData() {
				this.loading = true;
				const { data: res } = await this.$http.post("/share/list?isMe=1");
				this.loading = false;
				if (!res.success) {
					return this.$message.error(res.message);
				}
				console.log(res.result,'res.result')
				this.dataList = res.result || [];
			},
			getFileType(name) {
				let arr = name.split(".");
				return arr[arr.length - 1];
			},
			rowClick(row) {
				this.$refs.table.toggleRowSelection(row);
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			getSelection() {
				return new Promise((resolve) => {
					if (this.isList) {
						if (this.multipleSelection.length) {
							resolve(this.multipleSelection);
						} else {
							this.$message.warning(this.$t('myShare.txt10'));
						}
					} else {}
				});
			},
			async handleDeleteShare() {
				const list = await this.getSelection();
				
				this.$confirm('<p class="color666 fz14">'+this.$t('myShare.txt11')+'</p>', this.$t('myShare.txt12'), {
					dangerouslyUseHTMLString: true,
					confirmButtonText: this.$t('myShare.txt13'),
					cancelButtonText: this.$t('myShare.txt14'),
					type: 'warning',
					center: true,
				}).then(async e => {
					let promiseList = [];;
					list.forEach(item => {
						promiseList.push(this.$http.post( "/share/delete?id=" + item.id ))
					})
					Promise.all(promiseList).then(resList => {
						this.$message.success(this.$t('myShare.txt15'))
						this.loadData();
					}).catch(e => {
					})
				})
			},
			// 删除
			handleDelete(row) {
				let data = row;
				this.$ShowDeleteConfirmDialog
				.show({
					content: this.$t('myShare.txt16'),
				})
				.then((rs) => {
					this.delete(data);
				})
				.catch((drs) => {
					console.log("delete cancelled");
				});
			},
			// 搜索
			handleSearch() {
				this.queryInfo.pageNum = 1;
				this.queryInfo.pageSize = 10;
				this.loadData();
			},
		},
	};
</script>

<style lang="less" scoped>
	.showType {
		font-size: 1.4rem;
		font-weight: 400;
		color: #1b3b7c;
		height: 30px;
		line-height: 30px;
		cursor: pointer;
	}

	.searchBox {
		.flex {
			position: absolute;
			right: 0;
		}
	}

	.selectAll {
		padding: 3.7rem 3rem 1.7rem 3rem;
		border-bottom: 1px solid #eee;
	}

</style>
